package pnemonic.balloon_pop.model.tool

import pnemonic.balloon_pop.model.Bonus

class Score(bonus: Bonus.Score) : BonusTool(bonus)